export { default as About } from './about';
export { default as Heading } from './heading';
export { default as Intro } from './intro';
export { default as Job } from './job';
export { default as Navigation } from './navigation';
export { default as School } from './school';
export { default as SubHeading } from './sub-heading';
export { default as Footer } from './footer';
